export const DEMANDES_PAGE_SIZE = 20;

export function paginateList<T>(
  items: T[],
  page: number,
  pageSize: number = DEMANDES_PAGE_SIZE,
): { items: T[]; page: number; total: number; totalPages: number } {
  const total = items.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(Math.max(0, page), totalPages - 1);
  const start = safePage * pageSize;
  return {
    items: items.slice(start, start + pageSize),
    page: safePage,
    total,
    totalPages,
  };
}
